__webpack_require__.p = "/lannafood/";